import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { VehicleModelService } from '../../../components/crud-vehicle-module-cars/services/vehicle-model.service';
import { Vehicle } from '../../crud-vehicle-module-cars/vehicle';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrl: './vehicle.component.css',
})
export class VehicleComponent {
  //   @Input() vehicleId: Vehicle | null = null;
  @Output() close = new EventEmitter<void>(); // Evento para cerrar la modal
  vehicles: Vehicle[] = [];
  //   selectedVehicle: Vehicle | null = null;
  selectedVehicle!: Vehicle;
  showModal: boolean = false;
  ModalOds: boolean = false;
  tab1: string = 'medellin';

  constructor(
    private router: Router,
    private analitycs: AnalitycsService,
    private vehicleModelService: VehicleModelService,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    // this.analitycs.logEvent('init_page_vehicle', {
    //   pantalla: 'vehicle',
    //   accion: 'click',
    //   timestamp: new Date().toISOString(),
    //   plataforma: 'web',
    // });
    this.loadVehicles();
  }

  async loadVehicles(): Promise<void> {
    this.vehicles = await this.vehicleModelService.getVehicleModels();
  }

  Plate() {
    this.analitycs.logEvent('SEE_PLATE', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.router.navigate(['/plate']);
  }
  openPlateCityModal(): void {
    const modal = document.getElementById('platecityModal');
    if (modal) {
      modal.classList.remove('hidden'); // Mostrar el modal
    }
  }
  closePlateCityModal(): void {
    const modal = document.getElementById('platecityModal');
    if (modal) {
      modal.classList.add('hidden'); // Ocultar el modal
    }
  }

  async onDelete(vehicle: Vehicle): Promise<void> {
    this.analitycs.logEvent('eliminar_vehiculo', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });

    Swal.fire({
      toast: true,
      position: 'top',
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await this.vehicleModelService.inactivateVehicleModel(vehicle.id);
        Swal.fire({
          toast: true,
          position: 'top',
          icon: 'success',
          title: '¡Eliminado!',
          text: 'El vehículo ha sido eliminado correctamente.',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        this.vehicles = [];
        this.loadVehicles();
      }
    });
  }
  goCita(vehicle: Vehicle) {
    this.analitycs.logEvent('agendar_cita_desde_vehicle', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });

    const service = `para mi vehiculo con placa ${vehicle.plate}`;
    this.router.navigate(['/assistant'], { queryParams: { service: service } });
  }
  goCalendar() {
    this.analitycs.logEvent('ir_a_calendario_desde_vehicle', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.router.navigate(['/calendar']);
  }
  goDocumentation(vehicle: Vehicle) {
    this.analitycs.logEvent('ir_a_documentacion_desde_vehicle', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.router.navigate(['/documentation'], { queryParams: { id: vehicle.plate } });
  }

  handleVehicleCreated(vehicleCreated: any) {
    if (vehicleCreated) this.loadVehicles();
  }
  openEditModal(vehicle: any) {
    this.selectedVehicle = vehicle;
    this.showModal = true;
    this.ModalOds = false;
  }

  openOds(vehicle: any) {
    this.analitycs.logEvent('ir_a_ods_desde_vehicle', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });

    this.selectedVehicle = vehicle;
    this.ModalOds = true;
  }

  closeModal() {
    this.analitycs.logEvent('cerrar_modal_editar_vehiculo', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });

    this.showModal = false;
  }

  closeModalOds() {
    this.analitycs.logEvent('cerrar_modal_ods', {
      pantalla: 'vehicle',
      accion: 'click',
      timestamp: new Date().toISOString(),
      plataforma: 'web',
    });
    this.ModalOds = false;
  }
}
